import { SVGProps, Ref, forwardRef } from 'react';

export const GlobeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M6.162 7.3c.039-1.91.242-3.696.643-5.012.226-.743.484-1.232.725-1.512.204-.237.344-.274.459-.276h.022c.115.002.255.039.46.276.24.28.498.77.724 1.512.4 1.316.604 3.102.643 5.012z"
                    fill="currentColor"
                />
                <path
                    d="M4.757 7.3H.5c.194-3 1.677-5.85 5.425-6.606-.78 1.55-1.117 4.039-1.168 6.606"
                    fill="currentColor"
                />
                <path
                    d="M10.075.694c.78 1.55 1.117 4.039 1.168 6.606H15.5c-.194-3-1.677-5.85-5.425-6.606"
                    fill="currentColor"
                />
                <path
                    d="M9.838 8.7c-.039 1.91-.242 3.696-.643 5.012-.226.742-.484 1.232-.725 1.511-.211.246-.353.277-.47.277s-.259-.03-.47-.277c-.241-.28-.5-.769-.725-1.51-.4-1.317-.604-3.103-.643-5.013z"
                    fill="currentColor"
                />
                <path
                    d="M11.243 8.7H15.5c-.194 3-1.678 5.851-5.425 6.606.78-1.55 1.117-4.038 1.168-6.606"
                    fill="currentColor"
                />
                <path
                    d="M5.925 15.306C2.177 14.551.695 11.701.5 8.7h4.257c.05 2.568.388 5.057 1.168 6.606"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
GlobeFilledSize16Glyph.displayName = 'GlobeFilledSize16Glyph';
